const REDUCER_MENU_NAME = 'menu';

export {
  REDUCER_MENU_NAME,
};
